"use client";

import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
	rating: number;
	size?: "sm" | "md";
	interactive?: boolean;
	onRate?: (rating: number) => void;
}

export function StarRating({ rating, size = "md", interactive = false, onRate }: StarRatingProps) {
	const iconSize = size === "sm" ? "h-3.5 w-3.5" : "h-5 w-5";

	return (
		<div className="flex items-center gap-0.5">
			{[1, 2, 3, 4, 5].map((star) => {
				const starClass = cn(
					iconSize,
					star <= rating ? "fill-amber-400 text-amber-400" : "text-muted-foreground/30 fill-none",
				);
				// Non-interactive stars must not be <button> — e.g. ReviewSnippet wraps this in a row <button>;
				// nested buttons are invalid HTML and browsers rewrite the DOM (React #418 hydration).
				if (interactive) {
					return (
						<button
							key={star}
							type="button"
							onClick={() => onRate?.(star)}
							className="cursor-pointer transition-transform hover:scale-110"
						>
							<Star className={starClass} />
						</button>
					);
				}
				return (
					<span key={star} className="inline-flex cursor-default" aria-hidden="true">
						<Star className={starClass} />
					</span>
				);
			})}
		</div>
	);
}
